module.exports = __webpack_public_path__ + "img/syzxp02.98204198.png";